import { mediaMinWidth, mediaMaxWidth } from '@lux/core';
import styled from 'styled-components';
import { TabsContainer } from '../headerWrapper.styles';

export const SnackbarWrapper = styled.div<{ hasSmartBanner: boolean }>`
    position: fixed;
    z-index: 2000;
    top: ${({ hasSmartBanner }) => (hasSmartBanner ? '98px' : '60px')};
    overflow: hidden;
    width: 100%;

    ${mediaMinWidth.sm} {
        top: ${({ hasSmartBanner }) => (hasSmartBanner ? '100px' : '75px')};
    }

    // Ensure flash message appears when the Cart is Open on mobile web
    ${mediaMaxWidth.md} {
        z-index: 2025;
    }

    ${TabsContainer} {
        position: absolute;
        top: 0px;
    }
`;
